import { RemoveClient } from "@domain/models/RemoveClient";

export const removeCsvModel: {
  field: keyof RemoveClient;
  headerName: "CPF" | "NOME" | "PROCESSOS";
}[] = [
  {
    field: "id",
    headerName: "CPF",
  },
  {
    field: "name",
    headerName: "NOME",
  },
  {
    field: "processes",
    headerName: "PROCESSOS",
  },
];
